'use client';

import { useContext } from 'react';
import { AuthActionsContext } from './auth-provider.tsx';
import type { AuthActions } from './types.ts';

/**
 * Hook to access authentication actions.
 * Use this for components that trigger auth flows.
 *
 * @example
 * ```typescript
 * const { signIn, signOut } = useAuthActions();
 *
 * const handleLogin = async () => {
 *   const { error } = await signIn(email, password);
 *   if (error) setErrorMessage(error.message);
 * };
 *
 * ```
 */
export function useAuthActions(): AuthActions {
  const context = useContext(AuthActionsContext);
  if (!context) {
    throw new Error('useAuthActions must be used within AuthProvider');
  }
  return context;
}
